import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService).isLoggedIn;
  const router = inject(Router);  
  if(!auth){
    router.navigate(['/']);
  }
  return auth;
};
